import { get } from '../../base';

import { Order } from './types-orders';

export function getOrderById(orderId: string) {
  return get(`v3/merchants/orders/${orderId}`).json<Order>();
}
